module.exports = __webpack_public_path__ + "static/Agent-78fdedfd9c09422cc66b110472ace4d4.jpg";